/* Pixkom Wishlist — LocalStorage-based.
   Single identifier contract (Task 5.2): the product HANDLE, carried as
   data-product-handle on every heart button. Two button flavors exist:
   - .pk-wishlist-toggle  (1A product card, card-product.liquid)
   - .pixkom-wishlist-btn (PDP heart, main-product.liquid)
   Both toggle the same localStorage list of handles; the wishlist page
   (sections/pixkom-wishlist.liquid) renders cards from those handles. */
(function() {
  var STORAGE_KEY = 'pixkom-wishlist';
  var BTN_SELECTOR = '.pk-wishlist-toggle, .pixkom-wishlist-btn';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch(e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function isInWishlist(handle) {
    return getWishlist().indexOf(String(handle)) !== -1;
  }

  function notifyChange(handle, added) {
    document.dispatchEvent(new CustomEvent('pixkom:wishlist:change', {
      detail: { handle: String(handle), added: added, count: getWishlist().length }
    }));
  }

  function toggleWishlist(handle) {
    var list = getWishlist();
    var key = String(handle);
    var idx = list.indexOf(key);
    if (idx === -1) {
      list.push(key);
    } else {
      list.splice(idx, 1);
    }
    saveWishlist(list);
    updateAllButtons();
    updateWishlistCount();
    notifyChange(key, idx === -1);
    return idx === -1; // true if added
  }

  function updateAllButtons() {
    document.querySelectorAll(BTN_SELECTOR).forEach(function(btn) {
      var handle = btn.getAttribute('data-product-handle');
      var active = isInWishlist(handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function updateWishlistCount() {
    var count = getWishlist().length;
    document.querySelectorAll('.pixkom-wishlist-count').forEach(function(el) {
      if (count > 0) {
        el.textContent = count;
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    updateAllButtons();
    updateWishlistCount();

    document.addEventListener('click', function(e) {
      var btn = e.target.closest(BTN_SELECTOR);
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        var handle = btn.getAttribute('data-product-handle');
        if (handle) toggleWishlist(handle);
      }
    });
  });

  // Expose for wishlist page (all keys are product handles)
  window.PixkomWishlist = {
    getWishlist: getWishlist,
    isInWishlist: isInWishlist,
    toggleWishlist: toggleWishlist,
    removeFromWishlist: function(handle) {
      var list = getWishlist();
      var key = String(handle);
      var idx = list.indexOf(key);
      if (idx !== -1) {
        list.splice(idx, 1);
        saveWishlist(list);
        updateAllButtons();
        updateWishlistCount();
        notifyChange(key, false);
      }
    },
    // Re-sync hearts/count after injecting new DOM (wishlist page render)
    refresh: function() {
      updateAllButtons();
      updateWishlistCount();
    }
  };
})();
